import { render } from "./Slide7.vue?vue&type=template&id=47a07a05&scoped=true"
import script from "./Slide7.vue?vue&type=script&lang=js"
export * from "./Slide7.vue?vue&type=script&lang=js"

import "./Slide7.vue?vue&type=style&index=0&id=47a07a05&lang=scss&scoped=true"
import "./Slide7.vue?vue&type=style&index=1&id=47a07a05&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a07a05"]])

export default __exports__